"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var CashPrices_1 = require("../../prices/cash/CashPrices");
var CarDetailsPricesWithFinance_1 = require("./CarDetailsPricesWithFinance");
var carDetailsPricesWithFinanceStyles_1 = require("./carDetailsPricesWithFinanceStyles");
var CarDetailsPrices = function (props) {
    var primary = props.primary, secondary = props.secondary, isMultiCurrency = props.isMultiCurrency;
    var style = carDetailsPricesWithFinanceStyles_1.default();
    if (props.financeDetails) {
        return <CarDetailsPricesWithFinance_1.default {...props}/>;
    }
    return (<core_1.Box className={style.wrapper}>
      <CashPrices_1.default primaryPrice={primary} secondaryPrice={secondary} isMultiCurrency={isMultiCurrency} dataTest="summary:text:car_price"/>
    </core_1.Box>);
};
exports.default = CarDetailsPrices;
